// Account unico OmniSurv: SurvMaps sta sullo stesso dominio, quindi legge il
// token che OmniSurv salva in localStorage dopo il login (registrazione e
// accesso restano su OmniSurv).  I piani vengono dal backend SurvMaps
// (/api/account): abbonamento OmniSurv completo o abbonamento SurvMaps.

import { useCallback, useEffect, useRef, useState } from "react";
import { BACKEND, OMNI_AUTH_ME } from "./config";

const TOKEN_KEY = "survai.token";
const RECHECK_MS = 30_000; // al rientro sulla scheda, non più di una verifica ogni 30 s
const NO_PLANS = { omnisurv: false, survmaps: false };

export function readToken() {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function authHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

// status: "loading" | "anon" (nessun login) | "free" (loggato, senza abbonamento)
//         | "paid" (abbonamento OmniSurv o SurvMaps) | "offline" (OmniSurv non risponde)
// plans:  { omnisurv, survmaps }
export function useOmniAuth() {
  const [state, setState] = useState({ status: "loading", email: null, token: null, plans: NO_PLANS });
  const lastCheck = useRef(0);

  const check = useCallback(async () => {
    lastCheck.current = Date.now();
    const token = readToken();
    if (!token) {
      setState({ status: "anon", email: null, token: null, plans: NO_PLANS });
      return;
    }
    try {
      const res = await fetch(OMNI_AUTH_ME, { headers: authHeaders(token) });
      if (res.status === 401) {
        setState({ status: "anon", email: null, token: null, plans: NO_PLANS });
        return;
      }
      if (!res.ok) throw new Error(`auth ${res.status}`);
      const me = await res.json();
      let plans = { omnisurv: !!me.is_paid, survmaps: false };
      try {
        const acc = await fetch(`${BACKEND}/api/account`, { headers: authHeaders(token) });
        if (acc.ok) plans = (await acc.json()).piani;
      } catch { /* backend SurvMaps giù: vale l'abbonamento OmniSurv */ }
      setState({
        status: plans.omnisurv || plans.survmaps ? "paid" : "free",
        email: me.email || null,
        token,
        plans,
      });
    } catch {
      setState((s) => ({ ...s, status: "offline", token }));
    }
  }, []);

  useEffect(() => {
    check();
    const onFocus = () => {
      if (Date.now() - lastCheck.current > RECHECK_MS) check();
    };
    const onStorage = (e) => {
      if (e.key === TOKEN_KEY) check();
    };
    window.addEventListener("focus", onFocus);
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener("storage", onStorage);
    };
  }, [check]);

  return { ...state, refresh: check };
}
